export class ColorData {
    splash_cutom_bg_color:string=null;
  }


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/color-data.ts